import styled from 'styled-components';

export const Wrapper = styled.div`
  background-color: gray;
  position: absolute;

  transition: transform 0.3s;
`;
